module.exports = __webpack_public_path__ + "static/mems-089ea71ce89f2ec60e8b98a217a6aca4.jpg";